import { useState, useEffect, useContext } from 'react';
import { MapContext } from 'os-elements';
import useDpi from './useDpi';
import Units, { METERS_PER_UNIT } from 'ol/proj/Units.js';

export const INCHES_PER_METER = 1 / METERS_PER_UNIT[Units.FEET] * 12;

const metersToInches = (m) => {
    return m * INCHES_PER_METER;
};

export function useMapScale () {
    const [mapScale, setMapScale] = useState(0);
    const { map } = useContext(MapContext);
    const { dpi } = useDpi();

    useEffect(() => {
        map.on('postrender', updateInfo);
        return () => {
            map.un('postrender', updateInfo);
        };
    }, []);

    const updateInfo = () => {
        const view = map.getView();
        const unit = view.getProjection().getUnits();
        const resolution = view.getResolution();
        const scale = dpi * resolution * metersToInches(METERS_PER_UNIT[unit]);
        setMapScale(scale);
    };

    return mapScale;
}
